module.exports = __webpack_public_path__ + "img/4064015700.7b4c2468.jpg";